import {
    Redirect,
    Route,
    Switch
} from "react-router-dom";

import { ContactPage } from "../contact/ContactPage";
import CreateProperty from "../property/CreateProperty";
import { CustomerLinkBatchSetUpPage } from "../linkRegistry/CustomerLinkBatchSetUpPage";
import Home from "../home/Home";
import PropertiesPage from "../property/PropertiesPage";
import { PropertyDashboardPage } from "../property/PropertyDashboardPage";
import { PropertyManagerLinkSetUpPage } from "../linkRegistry/propertymanager/PropertyManagerLinkSetUpPage";
import { SettingsPage } from "../settings/SettingsPage";
import { UserProfile } from "../user/UserProfile";

export const PropertyManagerRoutes = () => {

    return (
        <Switch>
            <Route component={CreateProperty} path="/properties/create" exact />
            <Route component={Home} path="/" exact />
            <Route component={PropertiesPage} path="/properties" exact />
            <Route component={UserProfile} path="/profile" exact />
            <Route component={PropertyManagerLinkSetUpPage} path="/link-registry/:id" exact />
            <Route component={CustomerLinkBatchSetUpPage} path="/link-registry/" exact />
            <Route component={PropertyDashboardPage} path="/properties/:propertyId" />
            <Route component={ContactPage} path="/contacts" exact />
            <Route component={SettingsPage} path="/settings" exact />
            <Redirect to="/properties" />
        </Switch>
    );
};